<template>
  <div id="my-business-list">
    <user-settings-business
      v-if="!$store.state.AppActiveUser.paypingOauthId"
      :data="$store.state.AppActiveUser"
      :show-header="false"
    />
    <template v-else>
      <div v-for="business in myBusinesses" :key="business.id" :label="business.id">
        <vx-card class="mb-base">
          <div slot="no-body">
            <open-street-map
              class="responsive card-map-top"
              view-only
              :markers="
                business.places.map(p => {
                  return { latlng: [p.location.lat, p.location.lon], name: p.alias }
                })
              "
            />
          </div>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/5 md:w-1/4 sm:w-1/2 mb-2">
              <span>{{ $t('businesses.plans.plan') }}: </span>
              <span class="font-semibold"> {{ $t('businesses.plans.' + business.plan) }}</span>
            </div>
            <div class="vx-col w-full lg:w-1/5 md:w-1/4 sm:w-1/2 mb-2">
              <span>{{ $t('entity.state') }}: </span>
              <span class="font-semibold"> {{ $t('entity.states.' + business.state) }}</span>
            </div>
            <div class="vx-col w-full lg:w-1/5 md:w-1/4 sm:w-1/2 mb-2" v-if="business.website">
              <span>{{ $t('businesses.website') }}: </span>
              <span class="font-semibold"> {{ business.website }}</span>
            </div>
            <div class="vx-col w-full lg:w-1/5 md:w-1/4 sm:w-1/2 mb-2">
              <span>{{ $t('businesses.expiration_date') }}: </span>
              <span class="font-semibold"> {{ business.expirationDate | datetime }}</span>
            </div>
          </div>
        </vx-card>
        <div v-if="!$moment(business.expirationDate).isAfter($moment())">
          <vs-alert color="danger">{{ $t('messages.your_business_expired_please') }}</vs-alert>
        </div>
        <template v-else>
          <div class="vx-row mb-base">
            <div class="vx-col w-full">
              <h1 class="text-center">{{ $t('places.places') }}</h1>
              <vs-table
                ref="table"
                :data="business.places"
                class="vs-table places-table card-table"
                @selected="handleSelected"
              >
                <template slot="thead">
                  <vs-th sort-key="alias">{{ $t('places.alias') }}</vs-th>
                  <vs-th sort-key="category">{{ $t('places.category') }}</vs-th>
                  <vs-th sort-key="subject">{{ $t('places.subject') }}</vs-th>
                  <vs-th sort-key="state">{{ $t('places.employee_percent') }}</vs-th>
                  <vs-th sort-key="state">{{ $t('entity.state') }}</vs-th>
                  <vs-th sort-key="status">{{ $t('places.status') }}</vs-th>
                  <vs-th class="center">{{ $t('forms.actions') }}</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <tbody id="table-body" v-if="data.length">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td :data="tr.alias">{{ tr.alias }}</vs-td>
                      <vs-td :data="tr.category">{{ $t(`places.categories.${tr.category}`) }}</vs-td>
                      <vs-td :data="tr.subject">{{ $t(`places.subjects.${tr.subject}`) }}</vs-td>
                      <vs-td :data="tr.employeePercent">{{ tr.employeePercent | persian_digits }}</vs-td>
                      <vs-td :data="tr.state"><cell-badges :data="tr.state" local="entity.states."/></vs-td>
                      <vs-td :data="tr.status"
                        ><cell-badges :data="tr.status" local="places.statuses."
                      /></vs-td>
                      <vs-td>
                        <div>
                          <vs-button
                            :disabled="tr.state !== 'approved'"
                            size="small"
                            icon="icon-users"
                            icon-pack="feather"
                            class="w-full"
                            type="flat"
                            @click.stop="
                              $router.push({ name: 'business-place-service', params: { placeId: tr.id } })
                            "
                          >
                            {{ $t('personnel.personnel') }}
                          </vs-button>
                          <vs-button
                            size="small"
                            color="warning"
                            icon="icon-edit"
                            icon-pack="feather"
                            class="w-full"
                            type="flat"
                            @click.stop="
                              $router.push({ name: 'business-place-edit', params: { placeId: tr.id } })
                            "
                          >
                            {{ $t('forms.edit') }}
                          </vs-button>
                        </div>
                      </vs-td>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </div>
          </div>
          <div class="vx-row w-full">
            <div class="vx-col flex-1"></div>
            <div class="vx-col">
              <vs-button
                color="success"
                icon="icon-plus"
                icon-pack="feather"
                class="w-full"
                type="border"
                @click.stop="$router.push({ name: 'business-place-add' })"
              >
                {{ $t('forms.add') }}
              </vs-button>
            </div>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import moduleBusiness from '@/store/business/moduleBusiness'
import OpenStreetMap from '@/views/components/maps/OpenStreetMap'
import CellBadges from '@/views/components/common/table-cells/CellBadges'
import UserSettingsBusiness from '@/views/pages/profile/UserSettingsBusiness'

export default {
  name: 'Business',
  components: {
    UserSettingsBusiness,
    CellBadges,
    OpenStreetMap
  },
  data() {
    return {
      myBusinesses: null,
      businessNotFound: null
    }
  },
  created() {
    this.$vs.loading()
    if (!moduleBusiness.isRegistered) {
      this.$store.registerModule('business', moduleBusiness)
      moduleBusiness.isRegistered = true
    }
    this.$store.commit('business/SET_BUSINESSES_QUERY', {
      userId: this.$store.state.AppActiveUser.id
    })
    this.$store
      .dispatch('business/fetchBusinesses')
      .then(res => {
        this.myBusinesses = res.data.businesses
      })
      .catch(err => {
        if (err.response.status === 404) {
          this.businessNotFound = true
        }
      })
      .finally(() => this.$vs.loading.close())
  },
  methods: {
    handleSelected(place) {
      if (place.state === 'approved')
        this.$router.push({ name: 'business-place-service', params: { placeId: place.id } })
      else this.$notifyWarning(this.$t('places.place_not_approved'))
    }
  }
}
</script>

<style lang="scss">
#my-business-list {
  table:not(.vs-table) {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }
  }

  .card-map-top {
    overflow: hidden;
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
  }
}
</style>
